export const tableStyles = {
  container: {
    minHeight: '100vh',
    backgroundColor: '#f8fafc',
    position: 'relative' as const,
  },
  
  card: {
    backgroundColor: 'white',
    borderRadius: '12px',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
    overflow: 'hidden',
  },
  
  header: {
    backgroundColor: '#608ac4ff',
    color: 'white',
  },
  
  tableHeader: {
    fontWeight: 700,
    textTransform: 'uppercase' as const,
    letterSpacing: '1px',
    color: 'white',
    fontSize: '14px',
    py: 2,
  },
  
  weekHeader: {
    p: 2,
    fontSize: '16px',
    fontWeight: 700,
    color: 'white',
    textTransform: 'uppercase' as const,
    letterSpacing: '1px',
    minWidth: '400px',
    borderLeft: '2px solid rgba(255,255,255,0.3)',
  },
  
  tableRow: {
    incomplete: { backgroundColor: '#f8d7da' },
    completed: { backgroundColor: '#f0f8ff' },
    total: { 
      borderTop: '2px solid #374151',
      backgroundColor: '#f1f5f9'
    },
  },
  
  tabButton: {
    active: {
      backgroundColor: '#2563eb',
      color: 'white',
    },
    inactive: {
      backgroundColor: 'transparent',
      color: '#6b7280',
    },
  },
} as const;

export const colors = {
  success: '#16a34a',
  warning: '#85321eff',
  danger: '#dc2626',
  primary: '#2563eb',
  secondary: '#6b7280',
  background: {
    incomplete: '#f8d7da',
    completed: '#f0f8ff',
    success: '#acebe2ff',
    warning: '#eceecdff',
    danger: '#ffcccc'
  }
} as const;